import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progress"]
  static values = {
    duration: { type: Number, default: 5000 }
  }

  connect() {
    requestAnimationFrame(() => this.element.classList.add("toast-visible"))

    if (this.hasProgressTarget) {
      this.progressTarget.style.animationDuration = `${this.durationValue}ms`
    }

    if (this.durationValue > 0) {
      this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
    }
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    if (this.leaving) return
    this.leaving = true

    this.element.classList.remove("toast-visible")
    this.element.classList.add("toast-leave")

    setTimeout(() => this.element.remove(), 220)
  }
}
